<template>
  <div id="app">
    <loaderFull :isFullActive="true"></loaderFull>

    <router-view></router-view>
  </div>
</template>

<script>
import loaderFull from '@/components/prefab/structures/loaderFullScreen.vue'


export default {
  name: 'App',
  components: {
    loaderFull
  },
  data() {
    return {
      section: 'Head',
      loading: false
    }
  },
  methods: {}
}
</script>

<style>
#app {
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// App.vue?7a482800